import { render } from "./Fragment.vue?vue&type=template&id=b8253dae"
import script from "./Fragment.vue?vue&type=script&lang=ts"
export * from "./Fragment.vue?vue&type=script&lang=ts"
script.render = render

export default script